import React from 'react';
import { createContext } from 'react';

export const PDFDataContext = createContext({});

export function PDFDataContextProvider({ children, data, showImages }) {
  const pdfData = getPDFData(data, showImages);

  return <PDFDataContext.Provider value={pdfData}>{children}</PDFDataContext.Provider>;
}

function getPDFData(page, showImages) {
  return {
    page,
    title: page.title,
    logo: page.brandSettings?.logo?.url,
    travelDates: page.travelDates,
    preparedFor: page.preparedFor,
    companyName: page.brandSettings?.companyName,
    email: page.brandSettings?.email,
    phone: page.brandSettings?.contactPhone,
    primaryColor: page.brandSettings?.primaryColor,
    emergencyContacts: page.emergencyContacts || [],
    showImages,
  };
}
